import { useContext } from 'react';

import { TrackingContext } from '@spa/shared/contexts/tracking';
import events from './events';

export const useTracking = () => {
  const [state] = useContext(TrackingContext);
  const trackingServices = [
    import('@spa/shared/hooks/tracking/services/dataInfrastructure'),
    import('@spa/shared/hooks/tracking/services/dataLayer'),
    import('@spa/shared/hooks/tracking/services/eulerian/dataLayer')
  ];

  const track = (eventName, eventData, ...rest) =>
    Promise.all(
      trackingServices.map(async service => {
        const { track } = service.hasOwnProperty('track') ? service : (await service).default;

        track(eventName, { ...eventData, ...state }, ...rest);
      })
    );

  return { ...state, track, events };
};
